import { render, staticRenderFns } from "./IncomeCertificationConfirm.vue?vue&type=template&id=7c748c98&scoped=true&"
import script from "./IncomeCertificationConfirm.vue?vue&type=script&lang=js&"
export * from "./IncomeCertificationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c748c98",
  null
  
)

export default component.exports